import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Box } from '@mui/material';

const sliderImages = [
  './image_three.png',
  './image_four.png',
  './image_five.png',
];

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  arrows: false,
  appendDots: dots => (
    <Box
      component="ul"
      sx={{
        display: 'flex !important',
        justifyContent: 'center',
        padding: 0,
        mt: 1,
      }}
    >
      {dots}
    </Box>
  ),
  customPaging: () => (
    <Box
      sx={{
        width: 10,
        height: 10,
        borderRadius: '50%',
        backgroundColor: '#ff6600',
        mx: 0.5,
      }}
    />
  ),
};

const ImageSlider = () => (
  <Box
    sx={{
      width: '666px',
      height: '174px',
      mb: 4,
      mx: 'auto',
    }}
  >
    <Slider {...sliderSettings}>
      {sliderImages.map((src, index) => (
        <Box
          key={index}
          sx={{
            width: '666px',
            height: '174px',
            backgroundImage: `url(${src})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundColor: 'transparent',
          }}
        />
      ))}
    </Slider>
  </Box>
);

export default ImageSlider;
